export default __webpack_public_path__ + "static/media/msync4.2f4e739c.png";